import { AlicuotasIIBB } from "./AlicuotasIIBB";
import { ProvinciaParametroImpositivo } from "./ProvinciaParametroImpositivo";

export class Impuestos{
    parametroProvincia: ProvinciaParametroImpositivo;
    alicuotasIIBB: AlicuotasIIBB[];
}